import { format } from '@teetsh/app/src/utils/time/format';
import { UserLocale } from '@teetsh/app/src/types/user';
import { RegistreAppelPDFSettings } from 'containers/RegistreAppel/Print/Registre/types';

interface Props {
  from: Date;
  to: Date;
  lng: UserLocale;
  tz: string;
  settings: RegistreAppelPDFSettings;
}

export function buildRegistreAppelPDFParams({
  from,
  to,
  lng,
  tz,
  settings,
}: Props) {
  const params = new URLSearchParams({
    from: format(from, lng),
    to: format(to, lng),
    lng,
    tz,
    displayLegend: (settings.displayLegend ?? true).toString(),
    displayStats: (settings.displayStats ?? true).toString(),
    fontSize: (settings.fontSize || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 4).toString(),
    marginRight: (settings.marginRight ?? 4).toString(),
    marginBottom: (settings.marginBottom ?? 4).toString(),
    marginLeft: (settings.marginLeft ?? 4).toString(),
  });

  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
